import type { SVGProps } from "react";
const SenecPictogramBatteryCharge = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 5C18 3.34315 19.3431 2 21 2H27C28.6569 2 30 3.34315 30 5V7H36C37.6569 7 39 8.34315 39 10V43C39 44.6569 37.6569 46 36 46H12C10.3431 46 9 44.6569 9 43V42C9 41.4477 9.44772 41 10 41C10.5523 41 11 41.4477 11 42V43C11 43.5523 11.4477 44 12 44H36C36.5523 44 37 43.5523 37 43V10C37 9.44772 36.5523 9 36 9H12C11.4477 9 11 9.44772 11 10V37C11 37.5523 10.5523 38 10 38C9.44772 38 9 37.5523 9 37V10C9 8.34314 10.3431 7 12 7H18V5ZM28 5V7H20V5C20 4.44772 20.4477 4 21 4H27C27.5523 4 28 4.44772 28 5Z"
            fill="currentColor"
        />
        <path
            d="M24.2241 12.4643L20.3845 17.5971C20.2259 17.8091 20.3772 18.1111 20.6419 18.1111H23.2357C23.3422 18.1111 23.4286 18.1975 23.4286 18.304V21.4202C23.4286 21.6057 23.6648 21.6843 23.7759 21.5357L27.6155 16.4029C27.7741 16.1909 27.6228 15.8889 27.3581 15.8889H24.7643C24.6578 15.8889 24.5714 15.8025 24.5714 15.696V12.5798C24.5714 12.3943 24.3352 12.3157 24.2241 12.4643Z"
            fill="currentColor"
        />
        <path
            d="M13 41C13 40.4477 13.4477 40 14 40H34C34.5523 40 35 40.4477 35 41C35 41.5523 34.5523 42 34 42H14C13.4477 42 13 41.5523 13 41Z"
            fill="currentColor"
        />
        <path
            d="M14 35C13.4477 35 13 35.4477 13 36C13 36.5523 13.4477 37 14 37H34C34.5523 37 35 36.5523 35 36C35 35.4477 34.5523 35 34 35H14Z"
            fill="currentColor"
        />
        <path
            d="M13 31C13 30.4477 13.4477 30 14 30H34C34.5523 30 35 30.4477 35 31C35 31.5523 34.5523 32 34 32H14C13.4477 32 13 31.5523 13 31Z"
            fill="currentColor"
        />
        <path
            d="M14 25C13.4477 25 13 25.4477 13 26C13 26.5523 13.4477 27 14 27H34C34.5523 27 35 26.5523 35 26C35 25.4477 34.5523 25 34 25H14Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramBatteryCharge;
